import React, { useState, Fragment } from 'react';
import logo from '../../images/logo/psbank-logo.png';
import person from '../../images/icons/person_icon.png';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
  image: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3.8, 0, 2, 0),
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.only('md')]: {
      margin: theme.spacing('2rem', '0px', '1rem', '2rem'),
    },
    [theme.breakpoints.only('lg')]: {
      margin: theme.spacing('2rem', '0px', '1rem', '2rem'),
    },
    [theme.breakpoints.only('xl')]: {
      margin: theme.spacing('2rem', '0px', '1rem', '2rem'),
    },
  },

  imagePerson: {
    margin: theme.spacing(0, 0, 0, -3),
  },
  menuIcon: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    // flexWrap: 'wrap',
    // [theme.breakpoints.up('lg')]: {
    //   margin: theme.spacing(0, 15, 0, 8),
    // },
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    [theme.breakpoints.only('md')]: {
      margin: theme.spacing(1, 1),
    },
    [theme.breakpoints.only('lg')]: {
      margin: theme.spacing(1, 2),
    },
    [theme.breakpoints.only('xl')]: {
      margin: theme.spacing(1, 2),
    },
    fontSize: '13px',
  },

  navGrid: {
    // [theme.breakpoints.only('md')]: {
    margin: theme.spacing('1rem', '0rem', '2rem', '0rem'),
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  dateToday: {
    margin: theme.spacing('1rem', '0rem', '2rem', '0rem'),
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const TopNavigation = () => {
  const classes = useStyles();
  const dateNow = moment().format('MMMM DD, YYYY');
  const [state, setState] = useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  //insert d on REACT_APP_URL
  const menus = [
    {
      name: 'Home',
      url: `${process.env.REACT_APP_URL}`
    },
    {
      name: 'Pre-Owned Cars For Sale',
      url: `${process.env.REACT_APP_URL}pre-owned-cars-for-sale/`,
    },
    {
      name: 'Properties For Sale',
      url: `${process.env.REACT_APP_URL}properties-for-sale/`,
    },
    {
      name: 'Find ATM/Branch',
      url: `${process.env.REACT_APP_URL}atm-branch-finder/`,
    },
    {
      name: 'ATM Card PIN',
      url: `${process.env.REACT_APP_URL}AccountServices/`,
    },
    {
      name: 'Upload Docs',
      url: `${process.env.REACT_APP_URL}DocumentUpload/`,
    },
    {
      name: 'Advisories',
      url: `${process.env.REACT_APP_URL}advisories/`
    },
    {
      name: 'Contact',
      url: `${process.env.REACT_APP_URL}contact-us/`,
    },
  ];

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role='presentation'
      onClick={toggleDrawer(anchor, false)}
    >
      <List>
        {menus.map((menu, index) => (
          <ListItem button key={menu.name}>
            <Link color='textPrimary' href={menu.url} className={classes.link}>
              {menu.name}
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div>
      <AppBar
        position='static'
        color='transparent'
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Grid container>
            <Grid item xs={1} className={classes.menuIcon}>
              {['left'].map((anchor) => (
                <Fragment key={anchor}>
                  <IconButton onClick={toggleDrawer(anchor, true)}>
                    <MenuIcon />
                  </IconButton>
                  <Drawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                  >
                    {list(anchor)}
                  </Drawer>
                </Fragment>
              ))}
            </Grid>
            <Grid item xs={10} md={1} className={classes.image}>
              <Link href={process.env.REACT_APP_URL}>
                <img src={logo} alt='PSBank' />
              </Link>
            </Grid>
            <Grid item xs={1} className={classes.menuIcon}>
              <Link href={process.env.REACT_APP_URL} target='_blank'>
                <img
                  className={classes.imagePerson}
                  src={person}
                  alt='PSBOnline'
                />
              </Link>
            </Grid>
            <Grid item md={1} lg={1} xl={1} />
            <Grid item md={9} lg={9} xl={9}>
              <Grid item md={12} lg={12} xl={12}>
                <br />
              </Grid>
              <Grid item md={12} lg={12} xl={12} className={classes.navGrid}>
                <Grid item md={12} lg={12} xl={12} >
                  {menus.map((menu, index) => (
                    <Link
                      key={menu.name}
                      color='textPrimary'
                      href={menu.url}
                      className={classes.link}
                    >
                      {menu.name}
                    </Link>
                  ))}
                </Grid>
                <Grid
                  item
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.link}
                >
                  <br />
                  <Typography variant='body2' style={{ fontSize: '13px' }}>
                    {' '}
                    Today is {dateNow}
                  </Typography>{' '}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default TopNavigation;
